<app-common-header></app-common-header>
<main role="main" class="maincnt congrats quest">
  <div class="getbannersect sectppad pb-2 mt-1">
    <div class="sectpad container section">
      <div class="col-12 text-center webview">
        <!-- <img src="assets/images/signimg.jpg" class="signimg signimgg" /> -->
      </div>
      <div class="row">
        <div class="col-sm-5 float-left">
          <h1
            class="clrpink font-weight-bold-calibre text-left font50 mt-4 conmsg mobileview"
          >
            <span
              [innerHTML]="setConfirmationStatusPerEnergyProviders()"
            ></span>
          </h1>

          <p class="text-center mt-4 mobileview">
            <img class="mbwidth" src="{{ imagePath }}" width="80%" />
          </p>

          <h1
            class="clrpink font-weight-bold-calibre text-left font50 mt-4 conmsg webview"
          >
            <span
              [innerHTML]="setConfirmationStatusPerEnergyProviders()"
            ></span>
          </h1>
          <div class="mobileview">
              <p *ngIf="(postResultConfirmationDetails != null || postResultConfirmationDetails != undefined ) &&  IsShowPulsePowerRejectedMsg && postResultConfirmationDetails.ConfirmationStatus === 'Pending Deposit' && (selectedProduct.energy_provider === 'Pulse Power' || selectedProduct.energy_provider == 'New Power Texas')"
                 class="font16 orderNum"
                 style="
                color: #ed1277;
                font-size: 20px;
                font-family: Calibre;
                line-height: 20px !important;
                padding-top: 33px !important;
              ">
                  {{PulsePowerRejectedMsg}}
              </p>

               <p
              *ngIf="(postResultConfirmationDetails != null || postResultConfirmationDetails != undefined ) &&  !IsShowPulsePowerRejectedMsg && postResultConfirmationDetails.ConfirmationStatus === 'Pending Deposit' && (selectedProduct.energy_provider === 'Pulse Power' || selectedProduct.energy_provider == 'New Power Texas' || selectedProduct.energy_provider == 'Rhythm Energy' || selectedProduct.energy_provider == 'Shell Energy')"
              class="font16 orderNum"
              style="
                color: #ed1277;
                font-size: 20px;
                font-family: Calibre;
                line-height: 20px !important;
                padding-top: 33px !important;
              "
            >
              To finalize your enrollment,
              {{ selectedProduct.energy_provider }} will be emailing you soon
              with instructions. Be on the lookout for that email. If you’d like
              to ensure your success, you may contact their Customer Care Team
              via email:
              <span
                style="color: blue; cursor: pointer"
                (click)="mailMe(selectedProduct.providerEmail)"
                >{{ selectedProduct.providerEmail }}</span
              >
              | phone:
              <a
                [href]="selectedContactNumber()"
                style="color: blue !important"
              >
                {{ selectedProduct.providerContact }}</a
              >
            </p>
            <p
              *ngIf="getPostResultConfirmationDetails()"
              class="font16 orderNum"
              style="
                color: #ed1277;
                font-size: 20px;
                font-family: Calibre;
                line-height: 20px !important;
                padding-top: 33px !important;
              "
            >
              A {{ selectedProduct.energy_provider }} Customer Care team member
              will be contacting you soon to verify some additional information.
              If you wish to expedite the process and ensure your success, you
              may reach them via email:
              <span
                style="color: blue; cursor: pointer"
                (click)="mailMe(selectedProduct.providerEmail)"
                >{{ selectedProduct.providerEmail }}</span
              >
              | phone:
              <a
                [href]="selectedContactNumber()"
                style="color: blue !important"
              >
                {{ selectedProduct.providerContact }}</a
              >
            </p>

            <p *ngIf="orderNo != ''" class="font16">
              <span class="semi-bold">Order Confirmation Number:</span>
              <span>{{ orderNo }} </span>
            </p>
            <div><span class="semi-bold">Customer Name: </span>
              {{ customerName }}</div>
            <div>
              <span class="semi-bold">Service Address:</span>
              <span>{{ newFormattedAddress }} </span>
            </div>
            <div>
              <span class="semi-bold">ESIID:</span>
               <span>{{ ESIID }} </span>
            </div>
            <h2 class="mt-4 consubhead semibld font20 mb-1">
              Thank you for your business!
            </h2>
            <p class="font-weight-normal-calibre contxt">
              You did great by choosing
              <font class="txtclr">{{
                providerContact != undefined
                  ? providerContact.provider_name
                  : ''
              }}</font>
              as your new energy provider! We hope you like your new energy
              plan!
            </p>
            <p class="font-weight-normal-calibre contxt">
              When it comes to choosing an energy provider, we know you have
              many options. Thank you for using Honest Gorilla as your conduit
              to a better, brighter future!
            </p>
            <p class="mb-2 font-weight-normal-calibre contxt">
              As a valued member of the Honest Gorilla family, you can feel good
              knowing that a portion of the proceeds from your energy
              consumption will go towards the Light of Unity initiative.
              <a routerLink="/giveback"><u>Click here</u></a> to read how you
              will be contributing to the betterment of society and the impact
              you will make.
            </p>
          </div>
          <p class="text-left mt-4 webview">
            <img class="mbwidth" src="{{ imagePath }}" width="80%" />
          </p>
          <span
            *ngIf="confirmationStatusText"
            class="font16 orderNum"
            style="
              color: #ed1277;
              font-size: 20px;
              font-family: Calibre;
              line-height: 20px !important;
              padding-top: 33px !important;
            "
            >You met the credit criteria, but
            {{ selectedProduct.energy_provider }} is requiring additional
            documentation.
          </span>

          <span
            *ngIf="(postResultConfirmationDetails != null || postResultConfirmationDetails != undefined ) && !IsShowPulsePowerRejectedMsg && postResultConfirmationDetails.ConfirmationStatus === 'Pending Deposit' &&  (selectedProduct.energy_provider === 'Pulse Power' || selectedProduct.energy_provider == 'New Power Texas'|| selectedProduct.energy_provider == 'Rhythm Energy' || selectedProduct.energy_provider == 'Shell Energy')"
            class="font16 orderNum"
            style="
              color: #ed1277;
              font-size: 20px;
              font-family: Calibre;
              line-height: 15px !important;
              padding-top: 33px !important;
            "
          >
            It looks like a deposit is required for you to complete signing up
            for this plan.
          </span>

          <span
          *ngIf="(BKVDepositLink !== null && BKVDepositLink !== undefined && BKVDepositLink !== '') && selectedProduct.energy_provider === 'BKV Energy'"
          class="font16 orderNum"
          style="
            color: #ed1277;
            font-size: 20px;
            font-family: Calibre;
            line-height: 15px !important;
            padding-top: 33px !important;
          "
        >
          It looks like a deposit is required for you to complete signing up
          for this plan. <a href="{{BKVDepositLink}}" target="_blank" >Click here</a> to pay deposit. 
        </span>

          <span
          *ngIf="CEResponse === 'Deposit Needed'"
          class="font16 orderNum"
          style="
            color: #ed1277;
            font-size: 20px;
            font-family: Calibre;
            line-height: 15px !important;
            padding-top: 33px !important;
          "
        >
          It looks like a deposit is required for you to complete signing up
          for this plan.
        </span>
          <br />
          <p
            class="font16 orderNum webview"
            *ngIf="
             (selectedProduct.energy_provider === 'Chariot Energy' || selectedProduct.energy_provider === 'BKV Energy' )&&
              enableMessage === true
            "
            style="color: #ed1976; font-size: 19px !important"
          >
            <span
              >Your deposit waiver is pending review and needs to be verified.
            </span>
          </p>
          <br />
          <div class="servicemain">
            <div class="col-sm-12 col-md-11 col-lg-11 p-0">
              <h2 class="consubhead semibld mrgfour font20 mb-2">
                Product Details
              </h2>
              <div class="plansummary">
                <div class="d-flex">
                  <div class="col">
                    <div class="minhgt50p rateamt">
                      <div class="w-100 mt-2">
                        <img
                          style="max-height: 60px"
                          src="{{ selectedProduct.energy_provider_image }}"
                        />
                        <p
                          class="m-1 font15 font-weight-normal-calibre"
                          id="puctid"
                        >
                          PUCT #{{ selectedProduct.puct }}
                        </p>
                      </div>
                    </div>
                    <div class="minhgt50p">
                      <div class="w-100 mt-1">
                        <span
                          class="fwgtsix"
                          style="line-height: 10px; display: block"
                        >
                          {{ selectedProduct.product_key }}
                        </span>
                        <span
                          class="font-weight-normal-calibre wrdbrk headingText"
                          style="display: block"
                        >
                          {{ selectedProduct.terms }} Months - Fixed
                        </span>
                        <span
                          class="fwgtsix"
                          *ngIf="selectedProduct.Renewable"
                          style="line-height: 10px; display: block"
                        >
                          <a
                            class="pikclr"
                            style="padding-bottom: 8px"
                            target="_blank"
                            >{{ selectedProduct.Renewable }}% Renewable</a
                          >
                        </span>
                      </div>
                      <div
                        style="
                          clear: both;
                          cursor: pointer;
                          text-decoration: underline;
                        "
                        (click)="openDialog(selectedProduct)"
                      >
                        Show Details
                      </div>
                    </div>
                  </div>
                  <div class="col text-center">
                    <div class="minhgt50p rateamt">
                      <div class="w-100">
                        <h1 class="clrpink fwgtsix pikclr mb-0 avgvalue">
                          {{ averagePrice.toFixed(1) }}¢
                        </h1>
                        <p style="line-height: 13px">Avg. Price per kWh*</p>
                      </div>
                    </div>
                    <div class="minhgt50p rateamt">
                      <div class="w-100">
                        <h1 class="fwgtsix rate avgvalue mb-0">
                          ${{ avgbill }}
                        </h1>
                        <p style="line-height: 13px !important">
                          Avg. Monthly Bill Estimate*
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="plan" *ngIf="showAll === true">
                  <hr class="mt-2 mb-1" />
                  <div
                    class="col-4 col-sm-4 col-md-4 col-lg-4 plandesc pt-2 p-2"
                  >
                    <p class="fwgtsix">Description</p>
                    <p
                      class="font-weight-normal-calibre headingText"
                      [innerHTML]="selectedProduct.description"
                    ></p>
                  </div>

                  <div class="col-sm-8 col-md-8 col-lg-8 px-2 pb-2">
                    <p class="fwgtsix text-left font15">Pricing Details</p>
                    <table class="plantbl text-center">
                      <thead>
                        <th class="fwgtthree" width="28%">Monthly Usage</th>
                        <th class="fwgtthree">500 kWh</th>
                        <th class="fwgtthree">1000 kWh</th>
                        <th class="fwgtthree">2000 kWh</th>
                        <th class="fwgtthree bold">{{ avgMthlyUsage }} kWh</th>
                      </thead>
                      <tbody>
                        <td class="semi-bold" width="28%">
                          Average price per kWh
                        </td>
                        <td class="semi-bold">{{ t1_avg_charge }}¢</td>
                        <td class="semi-bold">{{ t2_avg_charge }}¢</td>
                        <td class="semi-bold">{{ t3_avg_charge }}¢</td>
                        <td class="semi-bold">
                          {{ averagePrice.toFixed(1) }}¢<font
                            class="fwgtthree"
                            style="line-height: 12px"
                            >Your Avg&#42;</font
                          >
                        </td>
                      </tbody>
                    </table>
                  </div>
                  <p
                    class="pl-2 font13 lh-120 hand-symbol"
                    *ngIf="partialText"
                    (click)="showText()"
                  >
                    *The estimates have been calculated to include all recurring
                    charges you will see on your bill, excluding government fees
                    and taxes. All numbers are ...
                  </p>
                  <p
                    class="pl-2 font13 content-scroll lh-120 hand-symbol"
                    (click)="partialText1()"
                    *ngIf="fullText"
                  >
                    *The estimates have been calculated to include all recurring
                    charges you will see on your bill, excluding government fees
                    and taxes. All numbers are estimates based on information
                    provided by you and each energy company. These estimates
                    should be confirmed using the information found in the
                    Electricity Facts Label and Terms of Service. Please note,
                    your Average Price per kWh and Average Monthly Bill Estimate
                    will vary each month according to your actual usage.
                  </p>

                  <div class="">
                    <div class="d-flex mt-1 p-2">
                      <div
                        class="col-4 d-flex flex-row forallmore pl-0 text-left"
                        *ngIf="!selectedProduct.Renewable"
                      >
                        <div class="float-left mr-0">
                          <img src="" width="18" />
                        </div>
                        <div>
                          <a
                            class="float-left pikclr pt-1"
                            style="padding-left: -0.75rem !important"
                            target="_blank"
                            >4% Renewable Energy</a
                          >
                        </div>
                      </div>

                      <div
                        class="col-4 d-flex flex-row forallmore pl-0 text-left"
                        *ngIf="selectedProduct.Renewable"
                      >
                        <div class="float-left mr-1">
                          <img
                            src="assets/images/leaf.png"
                            alt="Green leaf to signify renewable energy percentage for each product"
                            title="Renewable Energy Green Leaf"
                            width="18"
                          />
                        </div>
                        <div>
                          <a class="float-left pikclr pt-1" target="_blank"
                            >{{ selectedProduct.Renewable }}% Renewable
                            Energy</a
                          >
                        </div>
                      </div>

                      <div
                        class="col-2 d-flex flex-row forallmore pl-0 text-left"
                      >
                        <div class="float-left mr-1">
                          <img src="assets/images/pdf.svg" width="18" />
                        </div>
                        <div>
                          <a
                            class="float-left pikclr pt-1 pl-1"
                            href="{{ selectedProduct.productEFL }}"
                            target="_blank"
                            >EFL</a
                          >
                        </div>
                      </div>

                      <div
                        class="col-2 d-flex flex-row flexauto forallmore text-left"
                      >
                        <div class="float-left mr-1">
                          <img src="assets/images/pdf.svg" width="18" />
                        </div>
                        <div>
                          <a
                            class="float-left pikclr pt-1 pl-1"
                            href="{{ selectedProduct.productTOS }}"
                            target="_blank"
                            >TOS</a
                          >
                        </div>
                      </div>
                      <div
                        class="col-4 d-flex flex-row flexauto forallmore pr-0 text-left"
                      >
                        <div class="float-left mr-1">
                          <img src="assets/images/pdf.svg" width="18" />
                        </div>
                        <div>
                          <a
                            class="float-left pikclr pt-1 pl-1"
                            href="{{ selectedProduct.productYRAC }}"
                            target="_blank"
                            >YRAC</a
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- <div class="plansummary">
                <div class="d-flex bdrbot">
                  <div
                    class="
                      col-4 col-sm-4 col-md-4 col-lg-4
                      planrate
                      text-center
                    "
                  >
                    <div class="bdrbotgry minhgt50p rateamt">
                      <div class="w-100">
                        <h1 class="clrpink fwgtsix pikclr mb-0 avgvalue">
                          {{ averagePrice.toFixed(1) }}¢
                        </h1>
                        <p style="line-height: 13px">Avg. Price per kWh*</p>
                      </div>
                    </div>
                    <div class="minhgt50p rateamt">
                      <div class="w-100">
                        <h1 class="fwgtsix rate avgvalue mb-0">
                          ${{ avgbill }}
                        </h1>

                        <p style="line-height: 13px !important">
                          Avg. Monthly Bill Estimate*
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-8 col-md-8 col-lg-8 text-center p-0">
                    <table class="plansection">
                      <colgroup>
                        <col width="40%" />
                        <col width="20%" />
                        <col width="20%" />
                        <col width="20%" />
                      </colgroup>
                      <tbody>
                        <tr>
                          <td class="bdrbotgry position-relative">
                            <div class="w-45 float-left pr-2">
                              <p class="fwgtsix mt-1">Energy Provider</p>
                              <p
                                class="
                                  font-weight-normal-calibre
                                  wrdbrk
                                  headingText
                                "
                              >
                                {{ selectedProduct.energy_provider }}
                              </p>
                            </div>
                            <div class="w-50 float-left">
                              <img
                                src="{{
                                  selectedProduct.energy_provider_image
                                }}"
                                width="100%"
                              />
                              <p
                                class="m-1 font15 font-weight-normal-calibre"
                                id="puctid"
                              >
                                PUCT #{{ selectedProduct.puct }}
                              </p>
                            </div>
                          </td>
                          <td class="bdrbotgry">
                            <p class="fwgtsix">Plan Name</p>
                            <p
                              class="
                                font-weight-normal-calibre
                                wrdbrk
                                headingText
                              "
                            >
                              {{ selectedProduct.product_key }}
                            </p>
                          </td>
                          <td
                            class="bdrbotgry bdrrgtgry wd50"
                            style="width: 50% !important"
                          >
                            <p class="fwgtsix">Term</p>
                            <p
                              class="
                                font-weight-normal-calibre
                                wrdbrk
                                headingText
                              "
                            >
                              {{ selectedProduct.terms }} Months
                              {{ selectedProduct.categoryName }}
                            </p>
                          </td>
                          <td
                            class="bdrbotgry bdrlftgry wd50"
                            style="width: 50% !important"
                          >
                            <p class="fwgtsix">Early Cancellation</p>
                            <p
                              class="
                                font-weight-normal-calibre
                                wrdbrk
                                text-left
                              "
                              *ngIf="
                                selectedProduct.ETF &&
                                selectedProduct.ETFTypeId != 2
                              "
                            >
                              ${{ selectedProduct.ETF }}
                            </p>
                            <p
                              class="
                                font-weight-normal-calibre
                                wrdbrk
                                text-left
                              "
                              *ngIf="
                                selectedProduct.ETF &&
                                selectedProduct.ETFTypeId === 2
                              "
                            >
                              ${{ selectedProduct.ETF }} per month remaining
                            </p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="plan">
                  <div class="col-sm-4 col-md-4 col-lg-4 plandesc pt-2 p-2">
                    <p class="fwgtsix mb-1">Description</p>
                    <p
                      class="font-weight-normal-calibre headingText mb-1"
                      [innerHTML]="selectedProduct.description"
                    ></p>
                  </div>
                  <div class="col-sm-8 col-md-8 col-lg-8 px-2 pb-0">
                    <p class="fwgtsix text-left plandesc mb-1">
                      Pricing Details
                    </p>
                    <table class="plantbl text-center">
                      <thead>
                        <th class="fwgtthree" width="28%">Monthly Usage</th>
                        <th class="fwgtthree">500 kWh</th>
                        <th class="fwgtthree">1000 kWh</th>
                        <th class="fwgtthree">2000 kWh</th>
                        <th class="fwgtthree bold">{{ avgMthlyUsage }} kWh</th>
                      </thead>
                      <tbody>
                        <td class="semi-bold" width="28%">
                          Average price per kWh
                        </td>
                        <td class="semi-bold">{{ t1_avg_charge }}¢</td>
                        <td class="semi-bold">{{ t2_avg_charge }}¢</td>
                        <td class="semi-bold">{{ t3_avg_charge }}¢</td>
                        <td class="semi-bold">
                          {{ averagePrice.toFixed(1) }}¢<font
                            class="fwgtthree"
                            style="line-height: 12px"
                            >Your Avg&#42;</font
                          >
                        </td>
                      </tbody>
                    </table>
                  </div>
                </div>
                <p
                  class="pl-2 font13 lh-120 hand-symbol"
                  *ngIf="partialText"
                  (click)="showText()"
                >
                  *The estimates have been calculated to include all recurring
                  charges you will see on your bill, excluding government fees
                  and taxes. All numbers are ...
                </p>
                <p
                  class="pl-2 font13 content-scroll lh-120 hand-symbol"
                  (click)="partialText1()"
                  *ngIf="fullText"
                >
                  *The estimates have been calculated to include all recurring
                  charges you will see on your bill, excluding government fees
                  and taxes. All numbers are estimates based on information
                  provided by you and each energy company. These estimates
                  should be confirmed using the information found in the
                  Electricity Facts Label and Terms of Service. Please note,
                  your Average Price per kWh and Average Monthly Bill Estimate
                  will vary each month according to your actual usage.
                </p>
                <div>
                  <div class="d-flex mt-1 p-2">
                    <div
                      class="col-4 d-flex flex-row forallmore pl-0 text-left"
                      *ngIf="!selectedProduct.Renewable"
                    >
                      <div class="float-left"><img src="" width="18" /></div>
                      <div>
                        <a
                          class="float-left pikclr pt-1"
                          style="padding-left: -0.75rem !important"
                          target="_blank"
                          >4% Renewable Energy</a
                        >
                      </div>
                    </div>

                    <div
                      class="col-4 d-flex flex-row forallmore pl-0 text-left"
                      *ngIf="selectedProduct.Renewable"
                    >
                      <div class="float-left">
                        <img src="assets/images/leaf.png" width="18" />
                      </div>
                      <div>
                        <a
                          class="float-left pikclr pt-1"
                          style="padding-left: -0.75rem !important"
                          target="_blank"
                          >{{ selectedProduct.Renewable }}% Renewable Energy</a
                        >
                      </div>
                    </div>

                    <div
                      class="col-2 d-flex flex-row forallmore pl-0 text-left"
                    >
                      <div class="float-left mr-1">
                        <img src="assets/images/pdf.svg" width="18" />
                      </div>
                      <div>
                        <a
                          class="float-left pikclr pt-1 pl-1"
                          href="{{ selectedProduct.productEFL }}"
                          target="_blank"
                          >EFL</a
                        >
                      </div>
                    </div>

                    <div
                      class="
                        col-2
                        d-flex
                        flex-row
                        flexauto
                        forallmore
                        text-left
                      "
                    >
                      <div class="float-left mr-1">
                        <img src="assets/images/pdf.svg" width="18" />
                      </div>
                      <div>
                        <a
                          class="float-left pikclr pt-1 pl-1"
                          href="{{ selectedProduct.productTOS }}"
                          target="_blank"
                          >TOS</a
                        >
                      </div>
                    </div>

                    <div
                      class="
                        col-4
                        d-flex
                        flex-row
                        flexauto
                        forallmore
                        pr-0
                        text-left
                      "
                    >
                      <div class="float-left mr-1">
                        <img src="assets/images/pdf.svg" width="18" />
                      </div>
                      <div>
                        <a
                          class="float-left pikclr pt-1 pl-1"
                          href="{{ selectedProduct.productYRAC }}"
                          target="_blank"
                          >YRAC</a
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->
            </div>
          </div>

          <div class="mobileview">
            <br />
            <h2 class="mt-4 consubhead semibld mrgfour font20 mb-1">
              Special note about
              {{ selectedProduct.energy_provider }}
            </h2>
            <p class="font-weight-normal-calibre contxt">
              If you are switching REPs, you have the right to review and
              rescind the terms of service (TOS) without penalty within three
              (3) business days of receiving the TOS in this confirmation email.
              You may exercise your right by contacting
              <font class="txtclr">{{ selectedProduct.energy_provider }}</font
              >.
            </p>
            <p class="font-weight-normal-calibre contxt">
              Should you have any questions, feel free to reach out to
              <font class="txtclr">{{ selectedProduct.energy_provider }}</font>
              directly for assistance. They would love to hear from their newest
              customer! Their contact information is as follows:
            </p>
            <div
              class="col-lg-12 border text-center mb-4 brdrads d-flex mobileview"
            >
              <img
                src="{{ selectedProduct.energy_provider_image }}"
                class="text-center"
                width="136"
              />
              <!-- </div> -->

              <div class="">
                <p class="text-left mb-1 lneHgt">
                  <font class="font16 lnhgt19 semibld oneSpaces">PUCT#</font>
                  <font
                    class="font-weight-normal-calibre font16 lnhgt19 oneSpaces"
                    >{{ selectedProduct.puct }}</font
                  >
                </p>
                <p class="text-left mb-1 lneHgt">
                  <font class="font16 lnhgt19 semibld oneSpaces"
                    >Customer Service Hours:
                  </font>
                  <font
                    class="font-weight-normal-calibre font16 lnhgt19 oneSpaces"
                    >{{ selectedProduct.providerOperationHours }}</font
                  >
                </p>
                <p class="text-left mb-1 lneHgt">
                  <font class="font16 lnhgt19 semibld oneSpaces">Phone: </font>

                  <font
                    class="font-weight-normal-calibre font16 lnhgt19 oneSpaces"
                  >
                    <a
                      [href]="selectedContactNumber()"
                      style="color: blue !important"
                    >
                      {{ selectedProduct.providerContact }}</a
                    >
                  </font>
                </p>
                <p class="text-left mb-1 lneHgt">
                  <font class="font16 lnhgt19 semibld oneSpaces">Email: </font>
                  <font
                    class="font16 font-weight-normal-calibre lnhgt19 oneSpaces"
                  >
                    <span
                      style="
                        color: blue;
                        text-decoration: underline;
                        cursor: pointer;
                      "
                      (click)="mailMe(selectedProduct.providerEmail)"
                      >{{ selectedProduct.providerEmail }}</span
                    >
                  </font>
                </p>
                <p class="text-left mb-1 lneHgt">
                  <font class="font16 lnhgt19 semibld oneSpaces"
                    >Website:
                  </font>
                  <font
                    class="font16 font-weight-normal-calibre lnhgt19 oneSpaces"
                  >
                    <a
                      href="{{ selectedProduct.providerURL }}"
                      target="_blank"
                      style="color: blue; cursor: pointer !important"
                      >{{ selectedProduct.providerURL }}</a
                    ></font
                  >
                </p>
              </div>
            </div>

            <h2 class="mt-4 consubhead semibld mrgfour font20 mb-1">
              Next Steps
            </h2>
            <p class="font-weight-normal-calibre contxt">
              If you liked using our service and enjoyed your energy shopping
              experience, let us (and your friends on social media) know just
              how much!
            </p>
            <p class="font-weight-normal-calibre contxt">
              Like us on Facebook, Instagram and Twitter! Now there’s nothing
              left to do but share your amazing results with your friends.
            </p>
            <p class="font-weight-normal-calibre contxt">
              Go ahead and click an icon below:
            </p>

            <div class="social-icons">
              <a
                target="_blank"
                href="http://www.facebook.com/sharer.php?u={{ url }}"
                title="Facebook"
                class="mr-2 card p-1 boxcolour sgoptpad"
              >
                <span class="faceicon ml-1">
                  <a
                    href="http://www.facebook.com/sharer.php?u={{ url }}"
                    target="_blank"
                  >
                    <img src="assets/images/congfb.svg" width="20" />
                  </a>
                  <!-- <share-button button="facebook" url="https://dev.honestgorilla.com" size="3" theme="modern-dark"></share-button> -->
                </span>
                <span
                  class="fntwgtvle sgopt ml-1 font16 font-weight-bold-calibre align-middle"
                  >Facebook</span
                >
              </a>
              <a
                target="_blank"
                title="Instagram"
                href="https://www.instagram.com/honestgorilla_energy/ "
                class="mr-2 card p-1 boxcolour sgoptpad"
              >
                <span class="faceicon ml-1">
                  <img src="assets/images/conginstagram.svg" width="20" />
                </span>
                <span
                  class="fntwgtvle sgopt ml-1 font16 font-weight-bold-calibre align-middle"
                  >Instagram</span
                >
              </a>
              <a
                target="_blank"
                title="Twitter"
                href="https://twitter.com/share?url={{
                  url
                }}&amp;text=I%20just%20signed%20up%20for%20energy%20using%20Honest%20Gorilla%20and%20they’re%20giving%20back%20a%20portion%20of%20my%20usage!&amp;hashtags=lightofunity,light4light,electricity"
                class="mr-0 card p-1 boxcolour sgoptpad"
              >
                <span class="faceicon">
                  <a
                    href="https://twitter.com/share?url={{
                      url
                    }}&amp;text=I%20just%20signed%20up%20for%20energy%20using%20Honest%20Gorilla%20and%20they’re%20giving%20back%20a%20portion%20of%20my%20usage!&amp;hashtags=lightofunity,light4light,electricity"
                    target="_blank"
                  >
                    <img src="assets/images/congtwitter.svg" width="25" />
                  </a>
                </span>
                <span
                  class="fntwgtvle sgopt ml-1 font16 font-weight-bold-calibre align-middle"
                  >Twitter</span
                >
              </a>
            </div>
            <div style="text-align: center; margin-top: 30px">
              <!-- <a
                href="javascript:void(0)"
                style="
                  border-radius: 7px;
                  border: 1px solid #ed1976;
                  padding-left: 9px;
                  margin-left: 10px;
                  padding: 10px 20px;
                  font-size: 16px;
                  font-weight: bold;
                  color: #ed1976;
                "
                (click)="next()"
              >
                GO TO YOUR PROFILE</a
              > -->

              <!-- <a
                class="btn sectbtn addrbtn font19"
                href="javascript:void(0)"
                (click)="next()"
                >GO TO YOUR PROFILE</a
              > -->
            </div>
          </div>
        </div>
        <div class="col-sm-6 offset-sm-1 float-right px-0 webview">
          <p
            *ngIf="getPostResultConfirmationDetails()"
            class="font16 orderNum"
            style="
              color: #ed1277;
              font-size: 20px;
              font-family: Calibre;
              line-height: 20px !important;
              padding-top: 33px !important;
            "
          >
            To finalize your enrollment,
            {{ selectedProduct.energy_provider }} will be emailing you soon with
            instructions. Be on the lookout for that email. If you’d like to
            ensure your success, you may contact their Customer Care Team via
            email:
            <span
              style="color: blue; cursor: pointer"
              (click)="mailMe(selectedProduct.providerEmail)"
              >{{ selectedProduct.providerEmail }}</span
            >
            | phone:
            <a [href]="selectedContactNumber()" style="color: blue !important">
              {{ selectedProduct.providerContact }}</a
            >
          </p>
          <p
            *ngIf="getPostResultConfirmationDetails()"
            class="font16 orderNum"
            style="
              color: #ed1277;
              font-size: 20px;
              font-family: Calibre;
              line-height: 20px !important;
              padding-top: 33px !important;
            "
          >
            A {{ selectedProduct.energy_provider }} Customer Care team member
            will be contacting you soon to verify some additional information.
            If you wish to expedite the process and ensure your success, you may
            reach them via email:
            <span
              style="color: blue; cursor: pointer"
              (click)="mailMe(selectedProduct.providerEmail)"
              >{{ selectedProduct.providerEmail }}</span
            >
            | phone:
            <a [href]="selectedContactNumber()" style="color: blue !important">
              {{ selectedProduct.utility_contact_number }}</a
            >
          </p>

          <p
            *ngIf="CEResponse === 'Deposit Needed'"
            class="font16 orderNum"
            style="
              color: #ed1277;
              font-size: 20px;
              font-family: Calibre;
              line-height: 20px !important;
              padding-top: 33px !important;
            "
          >
            To finalize your enrollment,
            {{ selectedProduct.energy_provider }} will be emailing you soon with
            instructions. Be on the lookout for that email. If you’d like to
            ensure your success, you may contact their Customer Care Team via
            email:
            <span
              style="color: blue; cursor: pointer"
              (click)="mailMe(selectedProduct.providerEmail)"
              >{{ selectedProduct.providerEmail }}</span
            >
            | phone:
            <a [href]="selectedContactNumber()" style="color: blue !important">
              {{ selectedProduct.providerContact }}</a
            >
          </p>
          <p
          *ngIf="(postResultConfirmationDetails != null || postResultConfirmationDetails != undefined ) &&  !IsShowPulsePowerRejectedMsg && postResultConfirmationDetails.ConfirmationStatus === 'Pending Deposit' && (selectedProduct.energy_provider === 'Pulse Power' || selectedProduct.energy_provider == 'New Power Texas' || selectedProduct.energy_provider == 'Rhythm Energy' || selectedProduct.energy_provider == 'Shell Energy')"
          class="font16 orderNum"
          style="
            color: #ed1277;
            font-size: 20px;
            font-family: Calibre;
            line-height: 20px !important;
            padding-top: 33px !important;
          "
        >
          To finalize your enrollment,
          {{ selectedProduct.energy_provider }} will be emailing you soon with
          instructions. Be on the lookout for that email. If you’d like to
          ensure your success, you may contact their Customer Care Team via
          email:
          <span
            style="color: blue; cursor: pointer"
            (click)="mailMe(selectedProduct.providerEmail)"
            >{{ selectedProduct.providerEmail }}</span
          >
          | phone:
          <a [href]="selectedContactNumber()" style="color: blue !important">
            {{ selectedProduct.providerContact }}</a
          >
        </p>
        <p
          *ngIf="(postResultConfirmationDetails != null || postResultConfirmationDetails != undefined ) &&  IsShowPulsePowerRejectedMsg && postResultConfirmationDetails.ConfirmationStatus === 'Pending Deposit' && (selectedProduct.energy_provider === 'Pulse Power' || selectedProduct.energy_provider === 'New Power Texas' )"
          class="font16 orderNum"
          style="
            color: #ed1277;
            font-size: 20px;
            font-family: Calibre;
            line-height: 20px !important;
            padding-top: 33px !important;
          "
        >
          {{PulsePowerRejectedMsg}}
        </p>
        <p
          *ngIf="(postResultConfirmationDetails != null || postResultConfirmationDetails != undefined ) &&  postResultConfirmationDetails.ConfirmationStatus === 'Pending Deposit' && (selectedProduct.energy_provider == 'Rhythm Energy')"
          class="font16 orderNum"
          style="
            color: #ed1277;
            font-size: 20px;
            font-family: Calibre;
            line-height: 20px !important;
            padding-top: 33px !important;
          "
        >
          To finalize your enrollment,
          Please contact our Customer Care Team at 1-888-7RHYTHM to complete your enrollment.
          email:
          <span
            style="color: blue; cursor: pointer"
            (click)="mailMe(selectedProduct.providerEmail)"
            >{{ selectedProduct.providerEmail }}</span
          >
          | phone:
          <a [href]="selectedContactNumber()" style="color: blue !important">
            {{ selectedProduct.providerContact }}</a
          >
        </p>
          <p *ngIf="orderNo != ''" class="font16 orderNum" style="padding-top: 35px !important">
            Order Confirmation Number:
            <span class="semi-bold">{{ orderNo }} </span>
          </p>
          <div>Customer Name: {{ customerName }}</div>
          <div>
            Service Address:
            <span class="semi-bold">{{ newFormattedAddress }} </span>
          </div>
          <div>
            ESIID: <span class="semi-bold">{{ ESIID }} </span>
          </div>
          <div class="">
            <h2 class="mt-4 consubhead semibld font20 mb-1">
              Thank you for your business!
            </h2>
            <p class="font-weight-normal-calibre contxt">
              You did great by choosing
              <font class="txtclr">{{ selectedProduct.energy_provider }}</font>
              as your new energy provider! We hope you like your new energy
              plan!
            </p>
            <p class="font-weight-normal-calibre contxt">
              When it comes to choosing an energy provider, we know you have
              many options. Thank you for using Honest Gorilla as your conduit
              to a better, brighter future!
            </p>
            <p class="font-weight-normal-calibre contxt">
              As a valued member of the Honest Gorilla family, you can feel good
              knowing that a portion of the proceeds from your energy
              consumption will go towards the Light of Unity initiative.
              <a routerLink="/giveback" target="_blick"><u>Click here</u></a> to
              read how you will be contributing to the betterment of society and
              the impact you will make.
            </p>
            <h2 class="mt-4 consubhead semibld mrgfour font20 mb-1">
              Special note about {{ selectedProduct.energy_provider }}
            </h2>
            <p class="font-weight-normal-calibre contxt">
              If you are switching REPs, you have the right to review and
              rescind the terms of service (TOS) without penalty within three
              (3) business days of receiving the TOS in this confirmation email.
              You may exercise your right by contacting
              <font class="txtclr">{{ selectedProduct.energy_provider }}</font
              >.
            </p>energy_provider
            <p class="font-weight-normal-calibre contxt">
              Should you have any questions, feel free to reach out to
              <font class="txtclr">{{ selectedProduct.energy_provider }}</font>
              directly for assistance. They would love to hear from their newest
              customer! Their contact information is as follows:
            </p>
            <div
              class="col-lg-12 border p-0 float-left mb-4 brdrads d-flex webview"
            >
              <div class="col-4 col-md-4 margin: auto; position: relative">
                <img
                  src="{{ selectedProduct.energy_provider_image }}"
                  class="float-left"
                  width="136"
                  style="padding-right: 12px; padding-top: 15px"
                />
              </div>
              <div class="pl-0 col-8 col-md-8">
                <p class="text-left mb-1 lneHgt">
                  <font class="font16 lnhgt19 semibld oneSpaces"
                    >Customer Service Hours:
                  </font>
                  <font
                    class="font-weight-normal-calibre font16 lnhgt19 oneSpaces"
                    >{{ selectedProduct.providerOperationHours }}</font
                  >
                </p>
                <p class="text-left mb-1 lneHgt">
                  <font class="font16 lnhgt19 semibld oneSpaces">Phone: </font>
                  <font
                    class="font-weight-normal-calibre font16 lnhgt19 oneSpaces"
                  >
                    <a
                      [href]="selectedContactNumber()"
                      style="color: blue !important"
                    >
                      {{ selectedProduct.providerContact }}</a
                    >
                  </font>
                </p>
                <p class="text-left mb-1 lneHgt">
                  <font class="font16 lnhgt19 semibld oneSpaces">Email: </font>
                  <font
                    class="font16 font-weight-normal-calibre lnhgt19 oneSpaces"
                  >
                    <span
                      style="color: blue; cursor: pointer"
                      (click)="mailMe(selectedProduct.providerEmail)"
                      >{{ selectedProduct.providerEmail }}</span
                    >
                  </font>
                </p>

                <p class="text-left mb-1 lneHgt">
                  <font class="font16 lnhgt19 semibld oneSpaces"
                    >Website:
                  </font>
                  <font
                    class="font16 font-weight-normal-calibre lnhgt19 oneSpaces"
                  >
                    <a
                      href="{{ selectedProduct.providerURL }}"
                      target="_blank"
                      style="color: blue; cursor: pointer !important"
                      >{{ selectedProduct.providerURL }}</a
                    ></font
                  >
                </p>
              </div>
            </div>
            <div
              class="col-lg-12 border p-3 text-center mb-4 brdrads d-flex mobileview"
            >
              <div class="col-12 col-md-12 text-center">
                <img
                  src="{{ selectedProduct.energy_provider_image }}"
                  class="text-center"
                  width="136"
                />
              </div>
              <br />
              <div class="col-12 col-md-12">
                <p class="text-left mb-1 lneHgt">
                  <font class="font16 lnhgt19 semibld oneSpaces">PUCT#</font>
                  <font
                    class="font-weight-normal-calibre font16 lnhgt19 oneSpaces"
                    >{{ selectedProduct.puct }}</font
                  >
                </p>
                <p class="text-left mb-1 lneHgt">
                  <font class="font16 lnhgt19 semibld oneSpaces"
                    >Customer Service Hours:
                  </font>
                  <font
                    class="font-weight-normal-calibre font16 lnhgt19 oneSpaces"
                    >{{ selectedProduct.providerOperationHours }}</font
                  >
                </p>
                <p class="text-left mb-1 lneHgt">
                  <font class="font16 lnhgt19 semibld oneSpaces">Phone: </font>
                  <font
                    class="font-weight-normal-calibre font16 lnhgt19 oneSpaces"
                  >
                    <a
                      [href]="selectedContactNumber()"
                      style="color: blue !important"
                    >
                      {{ selectedProduct.providerContact }}</a
                    ></font
                  >
                </p>
                <p class="text-left mb-1 lneHgt">
                  <font class="font16 lnhgt19 semibld oneSpaces">Email: </font>
                  <font
                    class="font16 font-weight-normal-calibre lnhgt19 oneSpaces"
                  >
                    <span
                      style="
                        color: blue;
                        text-decoration: underline;
                        cursor: pointer;
                      "
                      (click)="mailMe(selectedProduct.ProviderEmail)"
                      >{{ selectedProduct.ProviderEmail }}</span
                    >
                  </font>
                </p>
                <p class="text-left mb-1 lneHgt">
                  <font class="font16 lnhgt19 semibld oneSpaces"
                    >Website:
                  </font>
                  <font
                    class="font16 font-weight-normal-calibre lnhgt19 oneSpaces"
                  >
                    <a
                      href="{{ selectedProduct.providerURL }}"
                      target="_blank"
                      style="color: blue; cursor: pointer !important"
                      >{{ selectedProduct.providerURL }}</a
                    ></font
                  >
                </p>
              </div>
            </div>
            <h2 class="mt-4 consubhead semibld mrgfour font20 mb-1">
              Next Steps
            </h2>
            <p class="font-weight-normal-calibre contxt">
              If you liked using our service and enjoyed your energy shopping
              experience, let us (and your friends on social media) know just
              how much!
            </p>
            <p class="font-weight-normal-calibre contxt">
              Like us on Facebook, Instagram and Twitter! Now there’s nothing
              left to do but share your amazing results with your friends.
            </p>
            <p class="font-weight-normal-calibre contxt">
              Go ahead and click an icon below:
            </p>

            <div class="social-icons text-center">
              <a
                href="http://www.facebook.com/sharer.php?u={{ url }}"
                title="Facebook"
                class="mr-3 card p-1 boxcolour m-1 sgoptpad"
                target="_blank"
              >
                <span class="faceicon">
                  <a
                    href="http://www.facebook.com/sharer.php?u={{ url }}"
                    target="_blank"
                  >
                    <img src="assets/images/congfb.svg" width="20" />
                  </a>
                  <!-- <share-button button="facebook" url="https://dev.honestgorilla.com" size="3" theme="modern-dark"></share-button> -->
                </span>
                <span
                  class="fntwgtvle sgopt ml-1 webview font16 font-weight-bold-calibre align-middle"
                  >Facebook</span
                >
              </a>
              <a
                title="Instagram"
                href="https://www.instagram.com/honestgorilla_energy/ "
                class="mr-3 card p-1 boxcolour m-1 sgoptpad"
                target="_blank"
              >
                <span class="faceicon">
                  <img src="assets/images/conginstagram.svg" width="20" />
                </span>
                <span
                  class="fntwgtvle sgopt ml-1 webview font16 font-weight-bold-calibre align-middle"
                  >Instagram</span
                >
              </a>
              <a
                target="_blank"
                title="Twitter"
                href="https://twitter.com/share?url={{
                  url
                }}&amp;text=I%20just%20signed%20up%20for%20energy%20using%20Honest%20Gorilla%20and%20they’re%20giving%20back%20a%20portion%20of%20my%20usage!&amp;hashtags=lightofunity,light4light,electricity"
                class="mr-3 card p-1 boxcolour m-1 sgoptpad"
              >
                <span class="faceicon">
                  <a
                    href="https://twitter.com/share?url={{
                      url
                    }}&amp;text=I%20just%20signed%20up%20for%20energy%20using%20Honest%20Gorilla%20and%20they’re%20giving%20back%20a%20portion%20of%20my%20usage!&amp;hashtags=lightofunity,light4light,electricity"
                    target="_blank"
                  >
                    <img src="assets/images/congtwitter.svg" width="25" />
                  </a>
                  <!-- <share-button button="twitter" [url]="url" tags="lightofunity,light4light,electricity" [description]="shareDescription" theme="modern-dark"></share-button> -->
                </span>
                <span
                  class="fntwgtvle sgopt ml-1 webview font16 font-weight-bold-calibre align-middle"
                  >Twitter</span
                >
              </a>
            </div>
            <div style="text-align: center; margin-top: 30px">
              <!-- <a
                href="javascript:void(0)"
                style="
                  border-radius: 7px;
                  border: 1px solid #ed1976;
                  padding-left: 9px;
                  margin-left: 10px;
                  padding: 10px 20px;
                  font-size: 16px;
                  font-weight: bold;
                  color: #ed1976;
                "
                (click)="next()"
                >GO TO YOUR PROFILE</a> -->
              <!-- <a
                class="btn sectbtn addrbtn font19"
                href="javascript:void(0)"
                (click)="next()"
                >GO TO YOUR PROFILE</a
              > -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="sectpad container section text-center">
      <div class="col-sm-12 p-0 pt-1 d-inline-block"></div>
    </div>
  </div>
</main>
<app-footer></app-footer>
